export let validateOpts = opts => {
  let { imgs, text } = opts.offers
  if(imgs.length === 0 && text.length === 0) {
    console.log('Chyba v opts, musi byt zadany alespon nejake offery!')
    return false
  }

  if(typeof opts.url !== 'string' || typeof  opts.url === 'undefined') {
    console.log('Chyba v opts - url!')
    return false
  }

  if(typeof opts.target !== 'string' || typeof opts.target === 'undefined') {
    console.log('Chyba v opts - target!')
    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/js/offers/validate-opts.js